export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.tenants = payload;

  return newState;
};
